import ai from './image/ai.jpg';
import clientlaptop from './image/clientlaptop.jpg';
import cloud from './image/cloud.jpg';
import cloud2 from './image/cloud2.jpg';
import code2 from './image/code2.jpg';
import comp from './image/comp.jpg';
import contact1 from './image/contact1.jpg';
import customsol from './image/customsol.jpg';
import cyber from './image/cyber.jpg';
import cyber2 from './image/cyber2.jpg';
import enterprise from './image/enterprise.jpg';
import galaxy from './image/galaxy.png';
import globe from './image/globe.jpg';
import home1 from './image/home1.jpg';
import home2 from './image/home2.jpg';
import home3 from './image/home3.jpg';
import home4 from './image/home4.jpg';
import image1 from './image/image1.jpg';
import industry2 from './image/industry2.jpg';
import industry3 from './image/industry3.jpg';
import laptop1 from './image/laptop1.jpg';
import laptop2 from './image/laptop2.jpg';
import laptop3 from './image/laptop3.jpg';
import map3 from './image/map3.jpg';
import mech from './image/mech.jpg';
import newcase1 from './image/newcase1.jpg';
import newcase2 from './image/newcase2.jpg';
import newcase3 from './image/newcase3.jpg';
import newcase4 from './image/newcase4.jpg';
import newpeople1 from './image/newpeople1.jpg';
import newpeople2 from './image/newpeople2.jpg';
import newpeople3 from './image/newpeople3.jpg';
import news1 from './image/news1.jpg';
import news2 from './image/news2.jpg';
import news3 from './image/news3.jpg';
import office1 from './image/office1.jpg';
import purplap from './image/purplap.jpg';
import purpleBanner from './image/purpleBanner.jpg';
import robot from './image/robot.jpg';
import robot3 from './image/robot3.jpg';
import tech from './image/tech.jpg';

const images = {
    ai,
    clientlaptop,
    cloud,
    cloud2,
    code2,
    comp,
    contact1,
    customsol,
    cyber,
    cyber2,
    enterprise,
    galaxy,
    globe,
    home1,
    home2,
    home3,
    home4,
    image1,
    industry2,
    industry3,
    laptop1,
    laptop2,
    laptop3,
    map3,
    mech,
    newcase1,
    newcase2,
    newcase3,
    newcase4,
    newpeople1,
    newpeople2,
    newpeople3,
    news1,
    news2,
    news3,
    office1,
    purplap,
    purpleBanner,
    robot,
    robot3,
    tech,
};

export default images;